<template>
    <div class="office_box no-trans" v-loading="loading">
            <div class="offices">
                <div class="title_box">
                    <div class="lefts">
                        <div class="title_text1">推荐事务所</div>
                        <div class="title_text2">REFERRAL FIRM</div>
                        <div class="title_img">
                            <img src="../../assets/img/index/home/right1.png" alt="">
                        </div>
                    </div>
                    <div class="rights">
                        <div class="btns2" role="button" tabindex="0" @keydown.enter.prevent="handle_lvsuo_add" @keydown.space.prevent="handle_lvsuo_add" @click="handle_lvsuo_add" v-if="vuex_is_law_firm_apply!=1">事务所入驻</div>
                    </div>
                </div>
                <div class="off_list_box">
                    <div class="off_list" v-for="(item, index) in list" :key="index">
                         <div class="item_top">
                            <img src="../../assets/img/index/home/lsuo.png" alt="">
                         </div>
                         <div class="item_bom">
                            <div class="item_title">{{ item.company }}</div>
                            <div class="item_tag">
                                <!-- <div class="tegs">房产债务</div> -->
                                <div class="tegs_text">{{ item.info }}</div>
                            </div>
                            <div class="item_address">
                             <img src="../../assets/img/index/home/address2.png" alt="">
                                {{ minx_get_province(item.province) }}
                            </div>
                         </div>
                        
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            list:[],
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number','vuex_is_law_firm_apply'])
    },
    watch: {

    },
    created() {
        this.get_list()
    },
    methods: {
        handle_lvsuo_add(){
            this.$api("getUserInfo", {
              
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.$emit('handle_lvsuo_add')
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_list(){
            this.loading=true
            this.$api("lawFirms", {
                limit:3,
			}, "get").then((res) => {
                this.loading = false
                console.log('律所1',res)
                if (res.code == 1) {
                  this.list=res.data.data
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
 .office_box {
        width: 100%;
        padding-top: 80px;
        background: #fff;

        .offices {
            width: 1440px;
            // height: 200px;
            // background-color: red;
            padding-bottom: 11px;
            margin: auto;

            .title_box {
              
                display: flex;
                align-items: end;
                // align-content: end;
                justify-content: space-between;
                .lefts{
                    display: flex;
                    align-items: end;
                    .title_text1 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 36px;
                        color: #333333;

                    }

                    .title_text2 {
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #377CFD;
                        margin-left: 16px;
                    }

                    .title_img {
                        width: 24px;
                        height: 24px;
                        margin-left: 16px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }
                }
                .rights{
                    display: flex;
                    align-items: center;
                    .btns1{
                        width: 180px;
                        height: 40px;
                        border-radius: 20px 20px 20px 20px;
                        border: 1px solid #377CFD;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        text-align: center;
                        line-height: 40px;
                    }
                    .btns2{
                        width: 180px;
                        height: 40px;
                        background: #377CFD;
                        border-radius: 20px 20px 20px 20px;
                        line-height: 40px;
                        cursor: pointer;
                        text-align: center;
                        font-weight: 400;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-left: 16px;
                    }
                }
                
            }

            .off_list_box {
                display: flex;
                align-items: center;
                // flex-wrap: wrap;
                
                justify-content: space-between;
                padding-top: 50px;
                .off_list{
                    width: 453px;
                    min-height: 417px;
                    background: #FFFFFF;
                    box-shadow: 0px 0px 40px 1px rgba(55,124,253,0.08);
                    border-radius: 8px 8px 8px 8px;
                    cursor: pointer;
                    .item_top{
                        width: 453px;
                        height: 255px;
                        border-radius: 8px 8px 0px 0px;
                        img{
                            width: 453px;
                            height: 255px;
                            border-radius: 8px 8px 0px 0px;
                        }
                    }
                    .item_bom{
                        padding: 16px 24px;
                        .item_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 24px;
                            color: #000B33;
                        }
                        .item_tag{
                            padding-top: 10px;
                            display: flex;
                            align-items: center;
                            padding-bottom: 24px;
                            border-bottom: 1px solid #EDEDED;
                            .tegs{
                                width: 72px;
                                height: 24px;
                                flex-shrink: 0;
                                background: #FDF6EC;
                                border-radius: 3px 3px 3px 3px;
                                border: 1px solid #FFAA00;
                                line-height: 24px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FFAA00;

                            }
                            .tegs_text{
                                // padding-left: 16px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }

                        }
                        .item_address{
                            padding-top: 18px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #333333;

                            img{
                                width: 18px;
                                // height: 16px;
                                margin-right: 8px;
                            }
                        }
                    }
                    
                }
                 
            }
        }
    }
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .office_box.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-top: 16px;
    }
    .office_box.no-trans .offices {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding-bottom: 11px;
        margin: auto;
    }
    .office_box.no-trans .offices .title_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .office_box.no-trans .offices .title_box .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .office_box.no-trans .offices .title_box .lefts .title_text1 {
        font-size: 24px;
    }
    .office_box.no-trans .offices .title_box .lefts .title_text2 {
        font-size: 24px;
        margin-left: 16px;
    }
    .office_box.no-trans .offices .title_box .lefts .title_img {
        width: 24px;
        height: 24px;
        margin-left: 16px;
    }
    .office_box.no-trans .offices .title_box .lefts .title_img img {
        width: 24px;
        height: 24px;
    }
    .office_box.no-trans .offices .title_box .rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .office_box.no-trans .offices .title_box .rights .btns1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .office_box.no-trans .offices .title_box .rights .btns2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        line-height: 1.6;
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .office_box.no-trans .offices .off_list_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .office_box.no-trans .offices .off_list_box .off_list {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 8px 8px 8px 8px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_top {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        border-radius: 8px 8px 0px 0px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_top img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
        min-height: 0;
        border-radius: 8px 8px 0px 0px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom {
        padding: 16px 16px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom .item_title {
        font-size: 24px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom .item_tag {
        padding-top: 10px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom .item_tag .tegs {
        width: 72px;
        height: 24px;
        border-radius: 3px 3px 3px 3px;
        line-height: 24px;
        font-size: 14px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom .item_tag .tegs_text {
        font-size: 14px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom .item_address {
        padding-top: 16px;
        font-size: 14px;
    }
    .office_box.no-trans .offices .off_list_box .off_list .item_bom .item_address img {
        width: 18px;
        margin-right: 8px;
    }
}
@media (max-width: 1024px) {
    .office_box.no-trans {
        padding-top: 24px;
        .offices {
            box-sizing: border-box;
            padding-bottom: 12px;
            .title_box .rights .btns2:focus-visible { outline: 2px solid #377cfd; outline-offset: 3px; }
            .off_list_box {
                display: grid;
                grid-template-columns: minmax(0, 1fr);
                align-items: stretch;
                gap: 0;
                padding-top: 12px;
                .off_list {
                    display: grid;
                    grid-template-columns: 88px minmax(0, 1fr);
                    align-items: start;
                    gap: 12px;
                    width: 100%;
                    min-height: 0;
                    padding: 16px 0;
                    box-sizing: border-box;
                    border-bottom: 1px solid #e9edf2;
                    border-radius: 0;
                    box-shadow: none;
                    cursor: default;
                    &:last-child { border-bottom: 0; }
                    .item_top { width: 88px; height: 88px; border-radius: 4px; overflow: hidden; background: #f1f4f8; }
                    .item_top img { display: block; width: 100%; height: 100%; object-fit: cover; border-radius: 4px; }
                    .item_bom {
                        min-width: 0;
                        padding: 0;
                        .item_title { color: #263447; font-size: 16px; font-weight: 600; line-height: 24px; overflow-wrap: anywhere; }
                        .item_tag { display: block; padding: 6px 0 0; border: 0; }
                        .item_tag .tegs_text { color: #748091; font-size: 13px; line-height: 21px; overflow-wrap: anywhere; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
                        .item_tag .tegs_text:empty { display: none; }
                        .item_address { display: flex; align-items: flex-start; gap: 5px; padding-top: 8px; color: #748091; font-size: 13px; line-height: 20px; overflow-wrap: anywhere; }
                        .item_address img { flex: 0 0 14px; width: 14px; height: 14px; object-fit: contain; margin: 3px 0 0; }
                    }
                }
            }
        }
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .office_box.no-trans .offices .off_list_box {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 20px;
        .off_list {
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 0;
            border: 0;
            .item_top { width: 100%; height: auto; aspect-ratio: ~"16 / 9"; }
            .item_bom { width: 100%; }
        }
    }
}
</style>
